import { render, staticRenderFns } from "./FavouriteSelected.vue?vue&type=template&id=906bfaa2"
var script = {}
import style0 from "./FavouriteSelected.vue?vue&type=style&index=0&id=906bfaa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports